import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  Heading1,
  Icon,
  IconVariant,
  JustifyContent,
  Text,
  TextAlign,
} from '@gousto-internal/citrus-react'
import type { CampaignBannerCtaItem } from '@library/api-menu-experience'

const onSpaceOrEnter =
  (callback: (event: React.KeyboardEvent) => void) => (event: React.KeyboardEvent) => {
    if (event.code === 'Space' || event.code === 'Enter') {
      event.preventDefault()
      callback(event)
    }
  }

const CAMPAIGN_TILE_WIDTH = 'min(82vw, 332px)'
const CAMPAIGN_TILE_HEIGHT = '352px'

export type CampaignBannerCtaCardProps = {
  item: CampaignBannerCtaItem
  onClick: (targetCategory: { id: string; slug: string }) => void
}
export const CampaignBannerCtaCard = ({ item, onClick }: CampaignBannerCtaCardProps) => (
  <button
    data-testid="campaign-banner-cta-card"
    type="button"
    onClick={() => onClick({ id: item.targetCategoryId, slug: item.targetCategorySlug })}
    onKeyDown={onSpaceOrEnter(() =>
      onClick({ id: item.targetCategoryId, slug: item.targetCategorySlug }),
    )}
    style={{
      background: 'transparent',
      border: 0,
      cursor: 'pointer',
      height: CAMPAIGN_TILE_HEIGHT,
      maxHeight: CAMPAIGN_TILE_HEIGHT,
      padding: 0,
      width: CAMPAIGN_TILE_WIDTH,
      boxShadow: '0 1px 4px 0 rgba(51, 61, 71, 0.1)',
    }}
  >
    <Box
      alignItems={AlignItems.Center}
      bg={Color.White}
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      justifyContent={JustifyContent.Center}
      gap={4}
      height="100%"
      width={CAMPAIGN_TILE_WIDTH}
      borderRadius={1.5}
      maxHeight={CAMPAIGN_TILE_HEIGHT}
      boxShadow="0 8px 10px -8px rgba(19, 35, 53, 0.18)"
    >
      <Heading1 color={Color.ColdGrey_900} textAlign={TextAlign.Center}>
        {item.title}
      </Heading1>
      <Box display={Display.Flex} alignItems={AlignItems.Center}>
        <Text color={Color.Secondary_400} fontWeight={FontWeight.Bold}>
          {item.ctaText}
        </Text>
        <Icon variant={IconVariant.Actionable} name="arrow_right" />
      </Box>
    </Box>
  </button>
)
